import Api from 'services/api';

export const ApiMiddleware =
  (client) =>
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    const { promise, types, ...rest } = action; // eslint-disable-line no-redeclare
    if (!promise) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;
    next({ ...rest, type: REQUEST });

    const actionPromise = promise(client);
    actionPromise
      .then(
        (result) => {
          if (result?.status >= 400) next({ ...rest, result, type: FAILURE });
          else next({ ...rest, result, type: SUCCESS });
        },
        (error) => next({ ...rest, error, type: FAILURE }),
      )
      .catch((error) => {
        console.error('💥 MIDDLEWARE ERROR:', error); // eslint-disable-line no-console
        // Api.get('frontend_errors', {
        //   params: {
        //     error: error.toString(),
        //     errorInfo: JSON.stringify(error, Object.getOwnPropertyNames(error)),
        //     location: window.location.pathname,
        //   },
        // });
        next({ ...rest, error, type: FAILURE });
      });

    return actionPromise;
  };
